import { render, staticRenderFns } from "./match-rank.vue?vue&type=template&id=019791ba"
import script from "./match-rank.vue?vue&type=script&lang=js"
export * from "./match-rank.vue?vue&type=script&lang=js"
import style0 from "./match-rank.vue?vue&type=style&index=0&id=019791ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports